import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleGrid from './components/ArticleGrid';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <CategoryGrid />
      <ArticleGrid />
      <ReviewSection />
      <CTASection />
      <Footer />
    </main>
  );
}